
import button from './button';
import utils from './utils';

const init = () => {

    let loadMoreButton = document.querySelector('[data-load-more]');

    if (!loadMoreButton) return;

    //currentPage = getURLParameter('page') != null ? getURLParameter('page') : 1;

    let currentPage = 1;

    loadMoreButton.addEventListener('click', function (e) {

        currentPage++;

        let queryArgs = loadMoreButton.getAttribute('data-load-more');
        let loadMoreButtonInner = loadMoreButton.querySelectorAll('.button-content');
        let oldLabel = loadMoreButtonInner[0].innerHTML;

        loadMoreButton.setAttribute('disabled', 'disabled');
        loadMoreButtonInner.forEach((el) => {
            el.innerHTML = 'Loading...';
        });

        queryArgs = JSON.parse(queryArgs);

        queryArgs.paged = currentPage;

        utils.getDataJson.post( window.site_url + '/wp-json/dynamicfns/loadmoreposts/', queryArgs ).then( result => {

            if(result?.htmlResult){

                let newCards = result.htmlResult;
                document.querySelector('.cards-grid').innerHTML += newCards;

                // Update button script
                button.init();

               	var stateObj = { foo: "bar" };
				history.pushState(stateObj, `page ${currentPage}`, "?page="+currentPage );
            }

            if(result?.query?.max_num_pages >= currentPage){
                loadMoreButtonInner.forEach((el) => {
                    el.innerHTML = 'No more posts';
                });
            }else{
                loadMoreButtonInner.forEach((el) => {
                    el.innerHTML = oldLabel;
                });
                loadMoreButton.removeAttribute('disabled');
            }
        });

    });
}

export default {init};